import React, { useState, useEffect } from "react";
import moment from "moment";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { loadUserMgmtFiltersDropdowns } from "redux/globalData/globalDataAction";

import { isFilterApplied } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant.js";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { InputLabelStyle } from "../../common/form-fields-mui/ASelect";
import {
  DEFAULT_FILTER_STATE,
  SOURCE_DROPDOWN,
  STATUS_DROPDOWN,
} from "./helper";

const UserFilters = ({
  filters,
  applyFilters,
  filterCount,
  setFilterCount,
  closeForm,
}) => {
  const [filterForm, setFilterForm] = useState(filters);

  const {
    designation,
    department,
    region,
    project,
    source,
    status,
    joiningDateFrom,
    joiningDateTo,
  } = filterForm;

  const dispatch = useDispatch();

  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );
  const [dropdowns, setDropdowns] = useState(masterDropdowns);

  useEffect(() => {
    if (
      !masterDropdowns.designation ||
      !masterDropdowns.department ||
      !masterDropdowns.regions ||
      !masterDropdowns.project
    )
      dispatch(loadUserMgmtFiltersDropdowns((res) => setDropdowns(res)));
    else setDropdowns(masterDropdowns);
  }, [masterDropdowns]);

  const handleApplyFilter = () => {
    if (filterForm?.["searchBy"]) delete filterForm.searchBy;
    if (filterForm?.["searchByValue"]) delete filterForm.searchByValue;

    const filterCount = isFilterApplied(filterForm);
    setFilterCount(filterCount);

    applyFilters(filterForm);
    closeForm();
  };

  const resetFilterForm = () => {
    closeForm();
    setFilterForm(DEFAULT_FILTER_STATE);
    applyFilters(DEFAULT_FILTER_STATE);

    setFilterCount(0);
  };

  const filterFormHandler = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            // height={inputHeight}
            label="Designation"
            items={dropdowns.designation}
            currentValue={designation}
            isShowCount={true}
            handleChange={(value) => {
              console.log("handleChange", value); //todo: rmv
              filterFormHandler(value, "designation");
            }}
            inputKey="designation"
          />

          <AAutoComplete
            // height={inputHeight}
            label="Department"
            items={dropdowns.department}
            currentValue={department}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "department");
            }}
            inputKey="department"
          />

          <AAutoComplete
            // height={inputHeight}
            label="Region"
            // placeholder="Batch"
            items={dropdowns.regions}
            currentValue={region}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "region");
            }}
            inputKey="region"
          />

          <AAutoComplete
            // height={inputHeight}
            label="Project"
            // placeholder="Batch"
            items={dropdowns.project}
            currentValue={project}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "project");
            }}
            inputKey="project"
          />

          <AAutoComplete
            label="Source"
            items={SOURCE_DROPDOWN}
            currentValue={source}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "source");
            }}
            inputKey="source"
          />

          <AAutoComplete
            label="Status"
            items={STATUS_DROPDOWN}
            currentValue={status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "status");
            }}
            inputKey="status"
          />

          <div>
            <InputLabel style={InputLabelStyle}>Joining Date</InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="From"
                  value={joiningDateFrom ? moment(joiningDateFrom) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "joiningDateFrom");
                  }}
                  maxDate={moment()}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="To"
                  value={joiningDateTo ? moment(joiningDateTo) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "joiningDateTo");
                  }}
                  minDate={moment(joiningDateFrom)}
                  maxDate={moment().startOf("day")}
                  disabled={!joiningDateFrom}
                />
              </Col>
            </Row>
          </div>

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !designation?.length &&
                !department?.length &&
                !region?.length &&
                !source?.length &&
                !project?.length &&
                !status?.length &&
                !joiningDateFrom &&
                !joiningDateTo
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default UserFilters;
